import { useState, useEffect } from 'react';
import { api } from '../api';
export function usePage(key) {
    const [page, setPage] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    useEffect(() => {
        if (!key) {
            setLoading(false);
            return;
        }
        setLoading(true);
        setError(null);
        api.page(key)
            .then(setPage)
            .catch(err => setError(err.message))
            .finally(() => setLoading(false));
    }, [key]);
    return { page, loading, error };
}
